export default __webpack_public_path__ + "75614cfcfedd509b1f7ac1c26c53bb7f.woff2";